import React from 'react';
import styled, { css } from 'styled-components';
import { BorderRadiusSmall, ColorNordicGrey4, FontSize16, Spacing8 } from 'autogen/design-tokens/tokens';
import type { ProductVariantSimpleModel } from 'autogen/swagger/all';
import { Body } from 'components/generic/typography';
import imageOverlayStyle from 'components/shared/style/imageOverlay';
import getGenericColorGrid from 'helpers/getGenericColorGrid';
import { getCloudFlareScaledUrl } from 'helpers/imageScalingHelper';

const VariantContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: ${Spacing8};
`;

const SwatchElement = styled.div<ProductVariantSimpleModel>`
    display: grid;
    width: 24px;
    height: 24px;
    border-radius: ${BorderRadiusSmall};
    overflow: hidden;

    ${({ colors, image, displayType }) => {
        if (displayType === 'Color' && colors && colors.length) {
            if (colors?.length > 1) {
                return getGenericColorGrid(colors);
            }

            return css`
                background-color: ${colors[0]};
            `;
        }

        if (displayType === 'Image' && image) {
            return css`
                position: relative;
                background-image: url(${getCloudFlareScaledUrl(image, 72, 'SquareScale', 'product', 2)});
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;

                &:after {
                    content: '';
                    ${imageOverlayStyle}
                }
            `;
        }

        // Fallback styling
        return css`
            background-color: ${ColorNordicGrey4};
            justify-content: center;
            align-items: center;

            &:before {
                content: '?';
                opacity: 0.5;
                font-size: ${FontSize16};
            }
        `;
    }}
`;

const ColorGridElement = styled.div<{ $color: string }>`
    background-color: ${({ $color }) => $color};
`;

const StyledBody = styled(Body)`
    margin-left: ${Spacing8};
`;

export default function Variant(props: ProductVariantSimpleModel) {
    const { colors, displayType, variantDisplayName } = props;

    return (
        <VariantContainer>
            <SwatchElement {...props}>
                {displayType === 'Color' &&
                    colors &&
                    colors.length > 1 &&
                    // eslint-disable-next-line react/no-array-index-key
                    colors.map((color, i) => <ColorGridElement key={i} $color={color} />)}
            </SwatchElement>
            <StyledBody as="span">{variantDisplayName}</StyledBody>
        </VariantContainer>
    );
}
